<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Manual <br>Check-out
      </h1>
      <br>
      <p class="subheader-style">
        How do you want to proceed manual <br>  check-out.
      </p>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <v-btn
        color="#37474F"
        class="mt-5 btn-style"
        elevation="0"
        :disabled="isCheckedInFromKiosk"
        @click="toOnSiteProcess()"
      >
        OnSite
      </v-btn>
      <v-btn
        light
        color="#E6E6E6"
        class="mt-3 btn-style"
        elevation="0"
        @click="toOffSiteProcess()"
      >
        OffSite
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ManualCheckout',
    data: () => ({
      showModal: true,
      loading: false,
    }),
    computed: {
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      isCheckedInFromKiosk () {
        if (Object.keys(this.activeCheckInDetails).length > 0 && this.activeCheckInDetails.checkin_kiosk !== null) {
          return true;
        }
        return false;
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      toOnSiteProcess () {
        this.$emit('on-site-selected');
      },
      toOffSiteProcess () {
        this.$emit('off-site-selected');
      },
    },
  };
</script>
<style scoped>
.v-btn.theme--dark.v-btn--disabled.v-btn--has-bg {
  background: rgba(202, 202, 202, 0.24) !important;
  color: white!important;
}
</style>
